import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { BehaviorSubject, Observable } from 'rxjs';
import { tap, share } from 'rxjs/operators';
import { ToastrService } from 'ngx-toastr';
import { Product } from '../model/product';
import { environment } from '../../environments/environment';
import { convertToQueryString } from '../utils';

interface SearchResponse {
  result: Product[];
  metadata: { pages: unknown[]; totalCount: number; pageSize: number };
}

@Injectable({ providedIn: 'root' })
export class SearchService {
  private http = inject(HttpClient);
  private toasterService = inject(ToastrService);
  router = inject(Router);


  results$: Observable<SearchResponse>;
  term$ = new BehaviorSubject('');

  url = (params: Record<string, string | number | boolean>): string =>
    `${environment.api}/v1/search/products?${convertToQueryString(params)}`;

  search(term: string): Observable<SearchResponse> {
    console.log(`search.service.fetch: ${term}`);
    this.term$.next(term);
    this.results$ = this.http.get<SearchResponse>(this.url({ term })).pipe(
      share(),
      tap((data: SearchResponse) => {
        data.result.forEach(product => {
          Product.enrich(product);
        });
        data.metadata.pages = Array(Math.ceil(data.metadata.totalCount / data.metadata.pageSize));
      })
    );
    return this.results$;
  }

  navigate(term: string): void {
    this.router.navigateByUrl(`/search?term=${encodeURIComponent(term)}`);
  }

}
